import React, {Component} from 'react';

import AppLink from "../AppLink";
import WithUserState from "../user/WithUserState";
import Menu from "./Menu";
import SearchBar from "../search/SearchBar";
import Icon from "../Icon";
import SignInButton from "../user/SignInButton";
import BurgerButton from "./BurgerButton";
import NavigationApi from "../../api/NavigationApi";
import SignOutButton from "../user/SignOutButton";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      menu: []
    }
  }

  componentDidMount() {
    NavigationApi.menu().then(res => {
      this.setState({
        loading: false,
        menu: res.data.primary
      });
    });
  }

  render() {
    const { loading, menu } = this.state;

    return (
      <header className={'page-header logo-' + (process.env.REACT_APP_LOGO)}>
        <section className={'main-section'}>
          <div className={'container mobile-header d-lg-none'}>
            <div className={'row no-gutters align-items-center'}>
              <div className={'col-1 col-md-1'}>
                <BurgerButton menu={menu} />
              </div>
              <div className={'col-2 col-md-1'}>
                <AppLink className={'logo-link'} to={"/"}>
                  <div className={'logo-img'} />
                </AppLink>
              </div>
              <div className={'col-7 col-md-9'}>
                <SearchBar/>
              </div>
              <div className={'col-2 col-md-1'}>
                <WithUserState state={"loggedIn"}>
                  <AppLink to={"/user"}>
                    <Icon icon={'user'} />
                  </AppLink>
                </WithUserState>
                <WithUserState state={"loggedOut"}>
                  <SignInButton className={'sign-in-btn'}>
                    <Icon icon={'user'} />
                  </SignInButton>
                </WithUserState>
              </div>
            </div>
          </div>
          <div className={'desktop-header d-none d-lg-block'}>
            <div className={'top-level'}>
              <div className={'container'}>
                <div className={'row align-items-center'}>
                  <div className={'col-6 col-xl-7'}>
                    <AppLink className={'logo-link'} to={"/"}>
                      <div className={'logo-img'} /> <span className={'font-weight-bold'}>{process.env.REACT_APP_TITLE}</span>
                    </AppLink>
                  </div>
                  <div className={'col-4'}>
                    <SearchBar/>
                  </div>
                  <div className={'col-2 col-xl-1 text-right'}>
                    <WithUserState state={"loggedIn"}>
                      <div className={'user-navigation'}>
                        <AppLink to={"/user"}>
                          <Icon icon={'user'} />
                        </AppLink>

                        <div className={'links'}>
                          <AppLink to={"/user"}>My Area</AppLink>
                          <AppLink to={"/user/favorites"}>Favorites</AppLink>
                          <AppLink to={"/user/subscriptions/new"}>Subscriptions</AppLink>
                          <SignOutButton>Logout</SignOutButton>
                        </div>
                      </div>
                    </WithUserState>
                    <WithUserState state={"loggedOut"}>
                      <SignInButton className={'sign-in-btn'}>
                        <Icon icon={'user'} />
                      </SignInButton>
                    </WithUserState>
                  </div>
                </div>
              </div>
            </div>

            <Menu loading={loading} menu={menu} />
          </div>
        </section>
      </header>
    );
  }
}

export default Header;